import { HostListener, Injectable } from '@angular/core';
declare var $;
declare var INSPIRO;
declare var DASHCODE;

@Injectable({
  providedIn: 'root'
})
export class DashCodeHelper {
  Settings = {
    // isMobile: Events.browser.isMobile,
    // submenuLight: $header.hasClass("submenu-light") == true ? true : false,
    // headerHasDarkClass: $header.hasClass("dark") == true ? true : false,
    headerDarkClassRemoved: false,
    sliderDarkClass: false,
    isSmallScreen: window?.innerWidth < 1281? true : false,
    menuIsOpen: false,
    menuIsCollapsed: false,
    menuIsExtended: false,
    menuOverlayOpened: false,
    menuCanCollapse: false,
};

  constructor() { }

  applyTheme(){
    var root = document.getElementsByTagName('html')[0];
  if (localStorage.theme) {
    var currentTheme = localStorage.theme;
    if (currentTheme == 'dark') {
      root.classList.add(currentTheme);
      root.classList.remove('light');
      root.classList.remove('semiDark');
    } else if (currentTheme == 'semiDark') {
      root.classList.add(currentTheme);
      root.classList.add('light');
    } else {
      root.classList.add(currentTheme);
      root.classList.remove('dark');
      root.classList.remove('semiDark');
    }
  }
  }

  documentReadyFunctions(){
    // alert('moli')
    DASHCODE.init()

    this.handleResize()
    // this.handleLocalStorage()
  }
  rowReadyFunctions(){
  }
  documentScrollFunctions(){
  }
  documentResizeFunctions(){

  }
  //   stickyHeader() {
  //     let $header = $("#header");

  //     //Check if header exist
  //     if ($header.length > 0) {
  //       let $headerOffsetTop = $header.offset().top;
  //       INSPIRO.header.stickyHeader($header,$headerOffsetTop);

  //         }

  // }

  // menu
  menuToggle(){
    // alert('moli')
    // Menu Hide and show toggle
      if (this.Settings.menuIsOpen) {
        this.Settings.menuIsOpen = false;
        // $(".sidebar-wrapper").addClass("menu-hide");
        // $(".sidebar-wrapper").removeClass("sidebar-open");
        // $("#menuCollapse").hide();
        // $(".app-header").addClass("margin-0");
        // $(".site-footer").addClass("margin-0");
        // $("#content_wrapper").addClass("margin-0");
      } else {
        this.Settings.menuIsOpen = true;
        // $(".sidebar-wrapper").removeClass("menu-hide");
        // $(".sidebar-wrapper").addClass("sidebar-open");
        // $("#menuCollapse").show();
        // $(".app-header").removeClass("margin-0");
        // $(".site-footer").removeClass("margin-0");
        // $("#content_wrapper").removeClass("margin-0");
      }
  }
  menuCollapse(){
     if(this.Settings.menuIsCollapsed || !this.Settings.menuCanCollapse){
      this.Settings.menuIsCollapsed = false;
      this.Settings.menuIsExtended = true;
        localStorage.sideBarType = "extend";
      } else {
        this.Settings.menuIsCollapsed = true;
        this.Settings.menuIsExtended = false;
        localStorage.sideBarType = "collapsed";
      }
  }

  private screenWidth() {
    console.log('screenWidth',window.innerWidth);
    this.Settings.menuIsOpen = false;
    this.Settings.isSmallScreen = window?.innerWidth < 1281? true : false;
    if (window?.innerWidth < 1281) {
      // toggle Sidebar
        this.Settings.menuIsOpen = false;
       this.Settings.menuCanCollapse = false
    } else {
      this.Settings.menuIsOpen = true
      this.Settings.menuCanCollapse = true

    }
  }

  public handleResize() {
    this.screenWidth();
  }


  public handleLocalStorage() {
    if (localStorage?.sideBarType == "extend") {
      this.Settings.menuIsCollapsed = false;
      this.Settings.menuIsExtended = true;
    } else if (localStorage?.sideBarType == "collapsed") {
      this.Settings.menuIsCollapsed = true;
      this.Settings.menuIsExtended = false;
    }
  }


  }
